import { setUser } from './actions';
import { prepareUser } from '../../mappers/user';
import { getUser } from '../../services/getUser';
import { TThunkAction } from '../../types/redux/thunk';

export function getUserAction(): TThunkAction<Promise<void>> {
  return async (dispatch, _getState, context) => {
    const userData = await getUser(context);

    const user = prepareUser(userData);
    dispatch(setUser(user));
  };
}
